<template>
  <div>
    <el-row>
      <el-col :sm="24">
        <el-form label-position="top" :inline="true">
          <el-form-item label="FAENAS" style="margin-bottom: 0px">
            <el-select
              @change="setValues"
              v-model="faena_selected"
              size="medium"
              placeholder="Seleccione Faena"
            >
              <el-option
                v-for="item in listadoFaenas"
                :key="item.faena_id"
                :label="item.nombre"
                :value="item.faena_id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Gerencias generales</small>
          </el-form-item>
          <el-form-item label="GERENCIAS GENERALES" style="margin-bottom: 0px">
            <el-select
              @change="setGerenciaGeneral"
              v-model="gerencia_general"
              size="medium"
              placeholder="Seleccione Gerencia General"
            >
              <el-option
                v-for="item in gerencias_generales"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Gerencias</small>
          </el-form-item>
          <el-form-item label="GERENCIAS" style="margin-bottom: 0px">
            <el-select
              @change="setGerencia"
              v-model="gerencia"
              size="medium"
              placeholder="Seleccione Gerencia"
            >
              <el-option
                v-for="item in gerencias"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Superintendencias</small>
          </el-form-item>
          <el-form-item label="SUPERINTENDENCIA" style="margin-bottom: 0px">
            <el-select
              @change="setSuperintendencia"
              v-model="superintendencia"
              size="medium"
              placeholder="Seleccione Superintendencia"
            >
              <el-option
                v-for="item in superintendencias"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Areas</small>
          </el-form-item>
          <el-form-item label="ÁREA" style="margin-bottom: 0px">
            <el-select
              @change="setArea"
              v-model="area"
              size="medium"
              placeholder="Seleccione área"
            >
              <el-option
                v-for="item in areas"
                :key="item._id"
                :label="item.nombre"
                :value="item._id"
              ></el-option>
            </el-select>
            <br />
            <small>(*) Sub-areas</small>
          </el-form-item>
          <el-form-item>
            <br />
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Filtros')"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Con los filtros usted podrá determinar la faena, la gerencia, la superintendencia y el área que desea consultar, no es obligatorio introducir todos los filtros.`
                )
              "
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <hr />
          <el-form-item label="FECHA INICIO">
            <el-input
              @change="getDataReporteGerencial"
              v-model="inicio"
              type="date"
              placeholder="Seleccione un día"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <br />
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Fecha inicio')"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Indica desde que fecha, usted desea extraer la información.`
                )
              "
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <el-form-item label="FECHA FIN">
            <el-input
              @change="getDataReporteGerencial"
              v-model="fin"
              type="date"
              placeholder="Seleccione un día"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <br />
            <el-popover
              class="help-box"
              placement="top"
              :title="$t('Fecha Fin')"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Indica hasta que fecha, usted desea extraer la información.`
                )
              "
            >
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </el-form-item>
          <hr v-if="inicio && fin" />
          <br v-if="inicio && fin" />
        </el-form>
      </el-col>
    </el-row>
    <el-alert
      v-if="inicio && fin"
      style="margin-bottom: 23px; font-size: 13px"
      type="info"
      show-icon
    >
      <template>
        <div style="color: black">
          <span>
            En esta tabla usted podrá visualizar el nº de riesgos pendientes de
            revisión, con mas de 10 días, su variación en el tiempo, respecto a
            las fechas seleccionadas. También podrá visualizar el tiempo medio
            de retraso en riesgos con más de 10 días, su variación en el tiempo,
            respecto a las fechas seleccionadas. Por último podrá ver la
            cantidad de Inventarios en borrador, en revisión y no iniciados de
            las gerencias seleccionadas en la sección de filtros.
          </span>
        </div>
      </template>
    </el-alert>
    <div id="reporteGerencial">
      <div
        class="ocultar"
        style="font-size: 22px; font-weight: bold; margin-bottom: 15px"
      >
        REPORTE MENSUAL PARA GERENTES
      </div>
      <div class="ocultar" style="font-weight: bold; margin-bottom: 15px">
        FECHA DEL REPORTE: {{ getToday() }}
      </div>
      <div class="ocultar" style="font-weight: bold; margin-bottom: 50px">
        FAENA: {{ getNameFaena(faena_selected) }}
      </div>
      <el-row v-if="inicio && fin">
        <el-col :sm="24">
          <table
            v-loading="loading"
            border="1"
            style="border-collapse: collapse; font-size: 13px"
          >
            <tr>
              <td
                rowspan="2"
                class="head"
                style="padding: 8px; text-align: center"
              >
                {{ data.titulo }}
              </td>
              <td
                colspan="4"
                class="head"
                style="padding: 8px; text-align: center"
              >
                N° de riesgos pendientes con más de 10 días
              </td>
              <td
                colspan="4"
                class="head"
                style="padding: 8px; text-align: center"
              >
                Tiempo medio de retraso en riesgos con más de 10 días
              </td>
              <td
                rowspan="2"
                class="head"
                style="padding: 8px; text-align: center; width: 100px"
              >
                Inventarios en borrador
              </td>
              <td
                rowspan="2"
                class="head"
                style="padding: 8px; text-align: center; width: 100px"
              >
                Inventarios en revisión
              </td>
              <td
                rowspan="2"
                class="head"
                style="padding: 8px; text-align: center; width: 100px"
              >
                Inventarios no iniciados
              </td>
            </tr>
            <tr>
              <td class="head" style="padding: 8px; text-align: center">
                {{ getDate(inicio) }}
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                {{ getDate(fin) }}
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                Variación
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                Variación (%)
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                {{ getDate(inicio) }}
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                {{ getDate(fin) }}
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                Variación
              </td>
              <td class="head" style="padding: 8px; text-align: center">
                Variación (%)
              </td>
            </tr>
            <tr v-for="(d, index) in data.head" :key="`A${index}`">
              <td style="padding: 8px">
                {{ d.nombre }}
              </td>
              <td style="padding: 8px; text-align: center">
                {{ getSuma(riesgosMasDies(getDate(inicio), d._id)) }}
              </td>
              <td style="padding: 8px; text-align: center">
                {{ getSuma(riesgosMasDies(getDate(fin), d._id)) }}
              </td>
              <td style="padding: 8px; text-align: center">
                {{
                  getSuma(riesgosMasDies(getDate(fin), d._id)) -
                  getSuma(riesgosMasDies(getDate(inicio), d._id))
                }}
              </td>
              <td style="padding: 8px; text-align: center">
                <span
                  v-if="
                    !isNaN(
                      ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                        getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                        100) /
                        getSuma(riesgosMasDies(getDate(inicio), d._id))
                    ) &&
                    ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                      getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                      100) /
                      getSuma(riesgosMasDies(getDate(inicio), d._id)) >=
                      0
                  "
                  >🔴</span
                >
                <span
                  v-if="
                    !isNaN(
                      ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                        getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                        100) /
                        getSuma(riesgosMasDies(getDate(inicio), d._id))
                    ) &&
                    ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                      getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                      100) /
                      getSuma(riesgosMasDies(getDate(inicio), d._id)) <
                      0
                  "
                  >🟢</span
                >
                {{
                  !isNaN(
                    ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                      getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                      100) /
                      getSuma(riesgosMasDies(getDate(inicio), d._id))
                  )
                    ? `${Math.round(
                        ((getSuma(riesgosMasDies(getDate(fin), d._id)) -
                          getSuma(riesgosMasDies(getDate(inicio), d._id))) *
                          100) /
                          getSuma(riesgosMasDies(getDate(inicio), d._id))
                      )}%`
                    : "-"
                }}
              </td>
              <!-- OTROOOOO -->

              <td style="padding: 8px; text-align: center">
                {{
                  getSumaTiempoPromedio(riesgosMasDies(getDate(inicio), d._id))
                }}
              </td>
              <td style="padding: 8px; text-align: center">
                {{ getSumaTiempoPromedio(riesgosMasDies(getDate(fin), d._id)) }}
              </td>
              <td style="padding: 8px; text-align: center">
                {{
                  getSumaTiempoPromedio(riesgosMasDies(getDate(fin), d._id)) -
                  getSumaTiempoPromedio(riesgosMasDies(getDate(inicio), d._id))
                }}
              </td>
              <td style="padding: 8px; text-align: center">
                <span
                  v-if="
                    !isNaN(
                      ((getSumaTiempoPromedio(
                        riesgosMasDies(getDate(fin), d._id)
                      ) -
                        getSumaTiempoPromedio(
                          riesgosMasDies(getDate(inicio), d._id)
                        )) *
                        100) /
                        getSumaTiempoPromedio(
                          riesgosMasDies(getDate(inicio), d._id)
                        )
                    ) &&
                    ((getSumaTiempoPromedio(
                      riesgosMasDies(getDate(fin), d._id)
                    ) -
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      )) *
                      100) /
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      ) >=
                      0
                  "
                  >🔴</span
                >
                <span
                  v-if="
                    !isNaN(
                      ((getSumaTiempoPromedio(
                        riesgosMasDies(getDate(fin), d._id)
                      ) -
                        getSumaTiempoPromedio(
                          riesgosMasDies(getDate(inicio), d._id)
                        )) *
                        100) /
                        getSumaTiempoPromedio(
                          riesgosMasDies(getDate(inicio), d._id)
                        )
                    ) &&
                    ((getSumaTiempoPromedio(
                      riesgosMasDies(getDate(fin), d._id)
                    ) -
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      )) *
                      100) /
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      ) <
                      0
                  "
                  >🟢</span
                >
                {{
                  !isNaN(
                    ((getSumaTiempoPromedio(
                      riesgosMasDies(getDate(fin), d._id)
                    ) -
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      )) *
                      100) /
                      getSumaTiempoPromedio(
                        riesgosMasDies(getDate(inicio), d._id)
                      )
                  )
                    ? `${Math.round(
                        ((getSumaTiempoPromedio(
                          riesgosMasDies(getDate(fin), d._id)
                        ) -
                          getSumaTiempoPromedio(
                            riesgosMasDies(getDate(inicio), d._id)
                          )) *
                          100) /
                          getSumaTiempoPromedio(
                            riesgosMasDies(getDate(inicio), d._id)
                          )
                      )}%`
                    : "-"
                }}
              </td>
              <td
                :style="`padding: 8px; text-align: center; font-weight: bold; color: ${
                  getSumaBorrador(data.data, d._id, getDate(fin)) === 0
                    ? 'green'
                    : 'red'
                }`"
              >
                {{ getSumaBorrador(data.data, d._id, getDate(fin)) }}
              </td>
              <td
                :style="`padding: 8px; text-align: center; font-weight: bold; color: ${
                  getSumaRevision(data.data, d._id, getDate(fin)) === 0
                    ? 'green'
                    : 'red'
                }`"
              >
                {{ getSumaRevision(data.data, d._id, getDate(fin)) }}
              </td>
              <td
                :style="`padding: 8px; text-align: center; font-weight: bold; color: ${
                  getSumaNoiniciado(data.data, d._id, getDate(fin)) === 0
                    ? 'green'
                    : 'red'
                }`"
              >
                {{ getSumaNoiniciado(data.data, d._id, getDate(fin)) }}
              </td>
            </tr>
          </table>
        </el-col>
      </el-row>
      <br v-if="inicio && fin" />
      <div class="saltopagina"></div>
      <el-row class="hidden" v-if="inicio && fin">
        <el-col :sm="24"
          ><div class="bottom-margin">
            <small
              ><b>FECHA DEL REPORTE: {{ getToday() }}</b></small
            >
          </div></el-col
        >
      </el-row>
      <el-row v-if="inicio && fin" class="hidden">
        <el-col :sm="24">
          <br />
          <el-form label-position="top" :inline="true">
            <el-form-item :label="`SELECCIONE ${tipo}`">
              <el-select
                style="width: 300px"
                @change="setDataFilter"
                v-model="area_filtro"
                size="medium"
                placeholder="Seleccione una opción"
              >
                <el-option
                  v-for="item in data.head"
                  :key="item._id"
                  :label="item.nombre"
                  :value="item._id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <br />
              <el-popover
                class="help-box"
                placement="top"
                :title="`Filtro de ${tipo.toLowerCase()}`"
                width="200"
                trigger="hover"
                :content="
                  $t(
                    `Debe filtrar la ${tipo.toLowerCase()} de la cuál requiere ver información más específica`
                  )
                "
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="`SELECCIONE UNA FECHA`">
              <el-select
                @change="setDataFilter"
                v-model="fecha_selected"
                size="medium"
                placeholder="Seleccione una opción"
              >
                <el-option
                  v-for="item in inicio && fin
                    ? [
                        { id: 1, fecha: getDate(inicio) },
                        { id: 2, fecha: getDate(fin) },
                      ]
                    : []"
                  :key="item.id"
                  :label="item.fecha"
                  :value="item.fecha"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <br />
              <el-popover
                class="help-box"
                placement="top"
                :title="`Selector de fecha`"
                width="200"
                trigger="hover"
                :content="
                  $t(`Debe seleccionar una de las fechas antes ingresadas.`)
                "
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="`SELECCIONE UN TIPO`">
              <el-select
                v-model="filtro_tipo"
                size="medium"
                placeholder="Seleccione una opción"
              >
                <el-option label="Propio y Contratista" value="all"></el-option>
                <el-option label="Propio" value="propio"></el-option>
                <el-option label="Contratista" value="contratista"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="inicio && fin && area_filtro && fecha_selected"
              label=""
            >
              <br />
              <el-button
                @click="PrintMe('reporteGerencial')"
                size="medium"
                type="primary"
                >DESCARGAR REPORTE</el-button
              >
            </el-form-item>
            <el-form-item v-if="inicio && fin && area_filtro && fecha_selected">
              <br />
              <el-popover
                class="help-box"
                placement="top"
                :title="`Descargar reporte`"
                width="200"
                trigger="hover"
                :content="$t(`Aquí podrá descargar el reporte en PDF.`)"
              >
                <i slot="reference" class="el-icon-question"></i>
              </el-popover>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div
        style="font-size: 13px"
        v-if="inicio && fin && area_filtro && fecha_selected"
      >
        <el-row>
          <el-col :sm="24" class="title">
            <b style="color: #dd5b32"
              >REPORTE MENSUAL PARA GERENTES - {{ getName(area_filtro) }}</b
            >
            <br /><br />
          </el-col>
          <el-col :sm="24">
            <div style="margin-top: 5px">
              FECHA DE LA DATA: {{ fecha_selected }}
            </div>
            <div style="margin-top: 5px">
              FAENA: {{ getNameFaena(faena_selected) }}
            </div>
          </el-col>
        </el-row>
        <br /><br />
        <el-row>
          <el-col :sm="24" class="title"
            ><b>INVENTARIOS APROBADOS V/S INVENTARIOS TOTALES</b
            ><el-popover
              class="help-box"
              placement="top"
              :title="`Inventarios aprobados v/s inventarios totales`"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Aquí podrá visualizar la cantidad total de inventarios de una gerencia y los inventarios aprobados de la misma, tanto propios como contratistas.`
                )
              "
            >
              <i
                style="margin-left: 10px"
                slot="reference"
                class="el-icon-question"
              ></i> </el-popover
            ><br /><br /><br
          /></el-col>
          <el-col
            :sm="8"
            :style="
              ['propio', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <div class="salto"></div>
            <apexchart
              width="410"
              type="bar"
              :options="options_1_p"
              :series="series"
            ></apexchart>
          </el-col>
          <el-col
            :sm="8"
            :style="
              ['contratista', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <apexchart
              width="410"
              type="bar"
              :options="options_1_c"
              :series="series_c"
            ></apexchart>
          </el-col>
          <el-col :sm="8">
            <div class="salto"></div>
            <div class="salto"></div>
            <div
              :style="
                ['propio', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>PROPIOS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    TOTAL
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    APROBADOS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ getTotalInvPropios(data_filter, fecha_selected) }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAprobadoPropio(data_filter, fecha_selected) }}
                  </td>
                </tr>
              </table>
            </div>
            <br /><br />
            <div
              :style="
                ['contratista', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>CONTRATISTAS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    TOTAL
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    APROBADOS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ getTotalInvContratista(data_filter, fecha_selected) }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAprobadoContratista(data_filter, fecha_selected) }}
                  </td>
                </tr>
              </table>
            </div>
          </el-col>
        </el-row>
        <br />
        <hr class="disable" />
        <br /><br />
        <div class="saltopagina"></div>
        <!-- PORCENTAJE DE CUMPLIMIENTO -->
        <el-row>
          <el-col :sm="24" class="title"
            ><b>PORCENTAJE DE CUMPLIMIENTO</b
            ><el-popover
              class="help-box"
              placement="top"
              :title="`Porcentaje de cumplimiento`"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Aquí se muestra el porcentaje de cumplimeinto de la gerencia seleccionada, esto corresponde a la cantidad de inventarios aprobados respecto al total, tanto propios como contratistas.`
                )
              "
            >
              <i
                style="margin-left: 10px"
                slot="reference"
                class="el-icon-question"
              ></i> </el-popover
            ><br /><br /><br
          /></el-col>
          <el-col
            :sm="8"
            :style="
              ['propio', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <div class="salto"></div>
            <apexchart
              width="430"
              type="donut"
              :options="options_2_p"
              :series="series_cumplimiento_p"
            ></apexchart>
          </el-col>
          <el-col
            :sm="8"
            :style="
              ['contratista', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <apexchart
              width="430"
              type="donut"
              :options="options_2_c"
              :series="series_cumplimiento_c"
            ></apexchart>
          </el-col>
          <el-col :sm="8">
            <div class="salto"></div>
            <div class="salto"></div>
            <div
              :style="
                ['propio', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>PROPIOS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    APROBADOS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_apr_p }}%
                  </td>
                </tr>
              </table>
            </div>
            <br /><br />
            <div
              :style="
                ['contratista', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>CONTRATISTAS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    APROBADOS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_apr_c }}%
                  </td>
                </tr>
              </table>
            </div>
          </el-col>
        </el-row>
        <br />
        <hr class="disable" />
        <br /><br />
        <div class="saltopagina"></div>
        <!-- RIESGOS PENDIENTES DE REVISIÓN MAYOR DE 10 DÍAS Y MENOR DE 10 DÍAS -->
        <el-row>
          <el-col :sm="24" class="title"
            ><b
              >RIESGOS PENDIENTES DE REVISIÓN MAYOR DE 10 DÍAS Y MENOR DE 10
              DÍAS</b
            ><el-popover
              class="help-box"
              placement="top"
              :title="`Riesgos pendientes de revisión mayor de 10 días y menores de 10 días`"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Aquí podrá visualizar los riesgos pendientes de revisión con más de 10 días y con menos de 10 días, tanto propios como contratistas.`
                )
              "
            >
              <i
                style="margin-left: 10px"
                slot="reference"
                class="el-icon-question"
              ></i> </el-popover
            ><br /><br /><br
          /></el-col>
          <el-col
            :sm="8"
            :style="
              ['propio', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <div class="salto"></div>
            <apexchart
              width="430"
              type="donut"
              :options="options_3_p"
              :series="series_mayor_menor_p"
            ></apexchart>
          </el-col>
          <el-col
            :sm="8"
            :style="
              ['contratista', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <apexchart
              width="430"
              type="donut"
              :options="options_3_c"
              :series="series_mayor_menor_c"
            ></apexchart>
          </el-col>
          <el-col :sm="8">
            <div class="salto"></div>
            <div class="salto"></div>
            <div
              :style="
                ['propio', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>PROPIOS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    MAYOR 10 DÍAS
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    MENOR 10 DÍAS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_may_10_p }}%
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_men_10_p }}%
                  </td>
                </tr>
              </table>
            </div>
            <br /><br />
            <div
              :style="
                ['contratista', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>CONTRATISTAS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    {{ tipo }}
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    MAYOR 10 DÍAS
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    MENOR 10 DÍAS
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">
                    {{
                      data_filter && data_filter.length > 0
                        ? data_filter[0]["nombre"]
                        : "-"
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_may_10_c }}%
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ porc_men_10_c }}%
                  </td>
                </tr>
              </table>
            </div>
          </el-col>
        </el-row>
        <br />
        <hr class="disable" />
        <br /><br />
        <div class="saltopagina"></div>
        <!-- PERSONAS CON RIESGOS PENDIENTES DE REVISIÓN -->
        <el-row>
          <el-col :sm="24" class="title"
            ><b>PERSONAS CON RIESGOS PENDIENTES DE REVISIÓN</b
            ><el-popover
              class="help-box"
              placement="top"
              :title="`Personas con riesgos pendientes de revisión`"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Aquí podrá visualizar un top 4 de las oersonas, propios y conlaboradores que tienen la mayor cantidad de riesgos pendientes de revisión.`
                )
              "
            >
              <i
                style="margin-left: 10px"
                slot="reference"
                class="el-icon-question"
              ></i> </el-popover
            ><br /><br /><br
          /></el-col>
          <el-col
            :sm="8"
            :style="
              ['propio', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <div class="salto"></div>
            <apexchart
              :key="render"
              width="430"
              type="bar"
              :options="options_5_p"
              :series="series_pend_p"
            ></apexchart>
          </el-col>
          <el-col
            :sm="8"
            :style="
              ['contratista', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <apexchart
              :key="render"
              width="430"
              type="bar"
              :options="options_5_c"
              :series="series_pend_c"
            ></apexchart>
          </el-col>
          <el-col :sm="8">
            <div class="salto"></div>
            <div class="salto"></div>
            <div
              :style="
                ['propio', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>PROPIOS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                  width: 300px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    NOMBRE
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    CANTIDAD
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in pendiente_select
                    ? [
                        pendiente_select.primero_pendiente_p,
                        pendiente_select.segundo_pendiente_p,
                        pendiente_select.tercero_pendiente_p,
                        pendiente_select.cuarto_pendiente_p,
                      ]
                    : []"
                  :key="`X${index}`"
                >
                  <td style="padding: 8px; text-align: center">
                    {{
                      `${item.usuario ? item.usuario.nombre : "--"} ${
                        item.usuario ? item.usuario.apellido : "--"
                      }`
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ item.cantidad ? item.cantidad : 0 }}
                  </td>
                </tr>
              </table>
            </div>
            <br /><br />
            <div
              :style="
                ['contratista', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>CONTRATISTAS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                  width: 300px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    NOMBRE
                  </td>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    CANTIDAD
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in pendiente_select
                    ? [
                        pendiente_select.primero_pendiente_c,
                        pendiente_select.segundo_pendiente_c,
                        pendiente_select.tercero_pendiente_c,
                        pendiente_select.cuarto_pendiente_c,
                      ]
                    : []"
                  :key="`XI${index}`"
                >
                  <td style="padding: 8px; text-align: center">
                    {{
                      `${item.usuario ? item.usuario.nombre : "--"} ${
                        item.usuario ? item.usuario.apellido : "--"
                      }`
                    }}
                  </td>
                  <td style="padding: 8px; text-align: center">
                    {{ item.cantidad ? item.cantidad : 0 }}
                  </td>
                </tr>
              </table>
            </div>
          </el-col>
        </el-row>
        <br />
        <hr class="disable" />
        <br /><br />
        <div class="saltopagina"></div>
        <!-- INVENTARIOS -->
        <el-row style="margin-bottom: 100px">
          <el-col :sm="24" class="title"
            ><b>INVENTARIOS</b
            ><el-popover
              class="help-box"
              placement="top"
              :title="`Inventarios`"
              width="200"
              trigger="hover"
              :content="
                $t(
                  `Aquí, podrá ver la cantidad de Inventarios en borrador, en revisión y no iniciados de las gerencias seleccionadas en la sección de filtros.`
                )
              "
            >
              <i
                style="margin-left: 10px"
                slot="reference"
                class="el-icon-question"
              ></i> </el-popover
            ><br /><br /><br
          /></el-col>
          <el-col
            :sm="8"
            :style="
              ['propio', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <div class="salto"></div>
            <apexchart
              width="430"
              type="bar"
              :options="options_4_p"
              :series="series_inv_p"
            ></apexchart>
          </el-col>
          <el-col
            :sm="8"
            :style="
              ['contratista', 'all'].includes(filtro_tipo)
                ? ''
                : 'display: none !important;'
            "
          >
            <apexchart
              width="430"
              type="bar"
              :options="options_4_c"
              :series="series_inv_c"
            ></apexchart>
          </el-col>
          <el-col :sm="8">
            <div class="salto"></div>
            <div class="salto"></div>
            <div
              :style="
                ['propio', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>PROPIOS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                  width: 300px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    ESTADO
                  </td>
                  <td
                    class="head_2"
                    style="padding: 8px; text-align: center"
                  ></td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">APROBADO</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllAprobadosPropios(data_filter, fecha_selected) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">BORRADOR</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllBorradorPropios(data_filter, fecha_selected) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">REVISIÓN</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllRevisionPropios(data_filter, fecha_selected) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">NO INICIADO</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllNoIniciadoPropios(data_filter, fecha_selected) }}
                  </td>
                </tr>
              </table>
            </div>
            <br /><br />
            <div
              :style="
                ['contratista', 'all'].includes(filtro_tipo)
                  ? ''
                  : 'display: none !important;'
              "
            >
              <b>CONTRATISTAS</b>
              <table
                border="1"
                style="
                  border-collapse: collapse;
                  font-size: 13px;
                  margin-top: 10px;
                  width: 300px;
                "
              >
                <tr>
                  <td class="head_2" style="padding: 8px; text-align: center">
                    ESTADO
                  </td>
                  <td
                    class="head_2"
                    style="padding: 8px; text-align: center"
                  ></td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">APROBADO</td>
                  <td style="padding: 8px; text-align: center">
                    {{
                      getAllAprobadosContratista(data_filter, fecha_selected)
                    }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">BORRADOR</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllBorradorContratista(data_filter, fecha_selected) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">REVISIÓN</td>
                  <td style="padding: 8px; text-align: center">
                    {{ getAllRevisionContratista(data_filter, fecha_selected) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 8px; text-align: center">NO INICIADO</td>
                  <td style="padding: 8px; text-align: center">
                    {{
                      getAllNoIniciadoContratista(data_filter, fecha_selected)
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      filtro_tipo: "all",
      pendiente_select: null,
      fecha_selected: "",
      series_pend_c: [],
      series_pend_p: [],
      series_inv_c: [],
      series_inv_p: [],
      porc_may_10_p: 0,
      porc_men_10_p: 0,
      porc_may_10_c: 0,
      porc_men_10_c: 0,
      porc_apr_c: 0,
      porc_apr_p: 0,
      render: 0,
      options_5_p: {
        title: {
          text: "PROPIOS",
        },
        xaxis: {
          categories: [],
        },
        colors: ["#dd5b32"],
      },
      options_5_c: {
        title: {
          text: "CONTRATISTAS",
        },
        xaxis: {
          categories: [],
        },
        colors: ["#dd5b32"],
      },
      options_4_p: {
        title: {
          text: "PROPIOS",
        },
        colors: ["#dd5b32", "#546E7A", "#87a0ab", "#d2dce0"],
      },
      options_4_c: {
        title: {
          text: "CONTRATISTAS",
        },
        colors: ["#dd5b32", "#546E7A", "#87a0ab", "#d2dce0"],
      },
      options_1_p: {
        title: {
          text: "PROPIOS",
        },
        colors: ["#546E7A", "#dd5b32"],
        legend: {
          show: false,
        },
      },
      options_1_c: {
        title: {
          text: "CONTRATISTAS",
        },
        colors: ["#546E7A", "#dd5b32"],
        legend: {
          show: false,
        },
      },
      options_2_p: {
        title: {
          text: "PROPIOS",
        },
        colors: ["#546E7A", "#dd5b32"],
        labels: ["Inventarios aprobados", "Inventarios no aprobados"],
      },
      options_2_c: {
        title: {
          text: "CONTRATISTAS",
        },
        colors: ["#546E7A", "#dd5b32"],
        labels: ["Inventarios aprobados", "Inventarios no aprobados"],
      },
      options_3_p: {
        title: {
          text: "PROPIOS",
        },
        colors: ["#546E7A", "#dd5b32"],
        labels: ["Riesgos mayor a 10 días", "Riesgos menor a 10 días"],
      },
      options_3_c: {
        title: {
          text: "CONTRATISTAS",
        },
        colors: ["#546E7A", "#dd5b32"],
        labels: ["Riesgos mayor a 10 días", "Riesgos menor a 10 días"],
      },
      series_c: [],
      series: [],
      series_cumplimiento_p: [],
      series_cumplimiento_c: [],
      series_mayor_menor_p: [],
      series_mayor_menor_c: [],
      data_filter: {},
      area_filtro: "",
      loading: false,
      area_master: "",
      data: [],
      inicio: "",
      fin: "",
      tipo: "",
      areas: [],
      superintendencias: [],
      area: "",
      superintendencia: "",
      area_id: "",
      gerencia_general: "",
      gerencia: "",
      gerencias: [],
      gerencias_generales: [],
      faena_selected: "",
      listadoFaenas: [
        {
          nombre: "MEL",
          faena_id: "5a6f78337b772dcfe68241d5",
        },
        {
          nombre: "SPENCE",
          faena_id: "5a6f78417b772dcfe68241e5",
        },
        {
          nombre: "CERRO COLORADO",
          faena_id: "5a6f784e7b772dcfe68241f4",
        },
        {
          nombre: "BHP",
          faena_id: "5b48f15d6f0ed90fc02826e3",
        },
      ],
    };
  },
  created() {
    if (JSON.stringify(this.$route.query) !== "{}") {
      localStorage.setItem("faena_dashboad", this.$route.query.faena);
    }
    this.faena_selected = localStorage.getItem("faena_dashboad");
    this.setValues();
  },
  methods: {
    PrintMe(printpage) {
      var headstr = `
        <html>
          <head>
            <title></title>
          </head>
          <style>
            @import url(http://fonts.googleapis.com/css?family=Roboto:400,100,100italic,300,300ita‌​lic,400italic,500,500italic,700,700italic,900italic,900);
            body{
              -webkit-print-color-adjust:exact;
            }
            html, body, html * {
              font-family: 'Roboto', sans-serif;
            }
            .resize-triggers {
              display: none !important;
            }
            .apexcharts-toolbar {
              display: none !important;
            }
            .hidden {
              display: none !important;
            }
            .bottom-margin {
              margin-bottom: 25px;
              margin-top: 25px;
            }
            @media all {
              div.saltopagina {
                display: none;
              }
            }
            @media print{
              div.saltopagina{
                display:block;
                page-break-before:always;
              }
              .head {
                background-color: #dd5b32;
                color: white;
                font-weight: bold;
              }
              .head_2 {
                background-color: gray;
                color: white;
                font-weight: bold;
              }
              .green {
                color: green;
              }

              .red {
                color: red;
              }
            }
            .disable {
              display: none !important;
            }
            .salto {
              height: 30px !important;
            }
            .title {
              font-size: 16px;
            }
          </style>
          <body>`;
      var footstr = "</body>";
      var newstr = document.all.item(printpage).innerHTML;
      var winPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
      );
      winPrint.document.write(headstr + newstr + footstr);
      winPrint.document.close();
      winPrint.focus();
      winPrint.print();
      winPrint.close();
    },
    getAllAprobadosContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.aprobado_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllBorradorContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.borrador_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllRevisionContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.revision_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllNoIniciadoContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.no_iniciado_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllAprobadosPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.aprobado_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllBorradorPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.borrador_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllRevisionPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.revision_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAllNoIniciadoPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.no_iniciado_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getMayorPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.mayor_dies_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getMenorPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.menor_dies_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getMayorContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.mayor_dies_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getMenorContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.menor_dies_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAprobadoPropio(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.aprobado_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getAprobadoContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total = total + d.aprobado_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getTotalInvPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total =
              total +
              d.borrador_propio +
              d.revision_propio +
              d.aprobado_propio +
              d.no_iniciado_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getTotalInvContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total =
              total +
              d.borrador_contratista +
              d.revision_contratista +
              d.aprobado_contratista +
              d.no_iniciado_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getTotalInvNoAprobadosPropios(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total =
              total +
              d.borrador_propio +
              d.revision_propio +
              d.no_iniciado_propio;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    getTotalInvNoAprobadosContratista(data, fecha) {
      if (data.length > 0) {
        var total = 0;
        data.forEach((d) => {
          if (d.fecha === fecha) {
            total =
              total +
              d.borrador_contratista +
              d.revision_contratista +
              d.no_iniciado_contratista;
          }
        });
        return total;
      } else {
        return 0;
      }
    },
    setDataFilter() {
      if (this.fecha_selected !== "") {
        var self = this;
        this.data_filter = this.data.data.filter(function (el) {
          return el.area_id === self.area_filtro;
        });
        if (this.data_filter.length > 0) {
          this.data_filter = this.data_filter;
        } else {
          this.data_filter = {};
        }

        this.series = [
          {
            name: "INVENTARIOS TOTALES",
            data: [
              {
                x: "INVENTARIOS TOTALES",
                y: [
                  this.getTotalInvPropios(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "INVENTARIOS APROBADOS",
              },
            ],
          },
          {
            name: "INVENTARIOS APROBADOS",
            data: [
              {
                x: "INVENTARIOS TOTALES",
              },
              {
                x: "INVENTARIOS APROBADOS",
                y: [
                  this.getAprobadoPropio(this.data_filter, this.fecha_selected),
                ],
              },
            ],
          },
        ];

        this.series_c = [
          {
            name: "INVENTARIOS TOTALES",
            data: [
              {
                x: "INVENTARIOS TOTALES",
                y: [
                  this.getTotalInvContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "INVENTARIOS APROBADOS",
              },
            ],
          },
          {
            name: "INVENTARIOS APROBADOS",
            data: [
              {
                x: "INVENTARIOS TOTALES",
              },
              {
                x: "INVENTARIOS APROBADOS",
                y: [
                  this.getAprobadoContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
            ],
          },
        ];

        /* propios */
        var cumpl_p = Math.round(
          (this.getAprobadoPropio(this.data_filter, this.fecha_selected) *
            100) /
            this.getTotalInvPropios(this.data_filter, this.fecha_selected)
        );
        this.porc_apr_p = cumpl_p;
        var cumpl_p_na = Math.round(
          (this.getTotalInvNoAprobadosPropios(
            this.data_filter,
            this.fecha_selected
          ) *
            100) /
            this.getTotalInvPropios(this.data_filter, this.fecha_selected)
        );
        this.series_cumplimiento_p = [cumpl_p, cumpl_p_na];
        /* contratistas */
        var cumpl_c = Math.round(
          (this.getAprobadoContratista(this.data_filter, this.fecha_selected) *
            100) /
            this.getTotalInvContratista(this.data_filter, this.fecha_selected)
        );
        this.porc_apr_c = cumpl_c;
        var cumpl_c_na = Math.round(
          (this.getTotalInvNoAprobadosContratista(
            this.data_filter,
            this.fecha_selected
          ) *
            100) /
            this.getTotalInvContratista(this.data_filter, this.fecha_selected)
        );
        this.series_cumplimiento_c = [cumpl_c, cumpl_c_na];

        this.series_mayor_menor_p = [
          this.getMayorPropios(this.data_filter, this.fecha_selected),
          this.getMenorPropios(this.data_filter, this.fecha_selected),
        ];
        this.series_mayor_menor_c = [
          this.getMayorContratista(this.data_filter, this.fecha_selected),
          this.getMenorContratista(this.data_filter, this.fecha_selected),
        ];

        this.porc_may_10_p =
          Math.round(
            (this.getMayorPropios(this.data_filter, this.fecha_selected) *
              100) /
              (this.getMayorPropios(this.data_filter, this.fecha_selected) +
                this.getMenorPropios(this.data_filter, this.fecha_selected))
          ) || 0;
        this.porc_men_10_p =
          Math.round(
            (this.getMenorPropios(this.data_filter, this.fecha_selected) *
              100) /
              (this.getMayorPropios(this.data_filter, this.fecha_selected) +
                this.getMenorPropios(this.data_filter, this.fecha_selected))
          ) || 0;

        this.porc_may_10_c =
          Math.round(
            (this.getMayorContratista(this.data_filter, this.fecha_selected) *
              100) /
              (this.getMayorContratista(this.data_filter, this.fecha_selected) +
                this.getMenorContratista(this.data_filter, this.fecha_selected))
          ) || 0;
        this.porc_men_10_c =
          Math.round(
            (this.getMenorContratista(this.data_filter, this.fecha_selected) *
              100) /
              (this.getMayorContratista(this.data_filter, this.fecha_selected) +
                this.getMenorContratista(this.data_filter, this.fecha_selected))
          ) || 0;

        this.series_inv_c = [
          {
            name: "APROBADO",
            data: [
              {
                x: "",
                y: [
                  this.getAllAprobadosContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "BORRADOR",
            data: [
              {
                x: "",
              },
              {
                x: "BORRADOR",
                y: [
                  this.getAllBorradorContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "REVISIÓN",
            data: [
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "REVISION",
                y: [
                  this.getAllRevisionContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "NO INICIADO",
            data: [
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "NO INICIADO",
                y: [
                  this.getAllNoIniciadoContratista(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
            ],
          },
        ];
        this.series_inv_p = [
          {
            name: "APROBADO",
            data: [
              {
                x: "",
                y: [
                  this.getAllAprobadosPropios(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "BORRADOR",
            data: [
              {
                x: "",
              },
              {
                x: "BORRADOR",
                y: [
                  this.getAllBorradorPropios(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "REVISIÓN",
            data: [
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "REVISION",
                y: [
                  this.getAllRevisionPropios(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
              {
                x: "",
              },
            ],
          },
          {
            name: "NO INICIADO",
            data: [
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "",
              },
              {
                x: "NO INICIADO",
                y: [
                  this.getAllNoIniciadoPropios(
                    this.data_filter,
                    this.fecha_selected
                  ),
                ],
              },
            ],
          },
        ];

        var self = this;

        var d = this.data_filter.find((x) => x.fecha === self.fecha_selected);

        if (d) {
          this.pendiente_select = d;

          this.series_pend_c = [
            {
              name: "Cantidad de riesgos pendientes",
              data: [
                d.primero_pendiente_c.cantidad,
                d.segundo_pendiente_c.cantidad,
                d.tercero_pendiente_c.cantidad,
                d.cuarto_pendiente_c.cantidad,
              ],
            },
          ];

          this.options_5_c.xaxis.categories = [
            `${
              d.primero_pendiente_c.usuario
                ? d.primero_pendiente_c.usuario.nombre
                : "--"
            } ${
              d.primero_pendiente_c.usuario
                ? d.primero_pendiente_c.usuario.apellido
                : "--"
            }`,
            `${
              d.segundo_pendiente_c.usuario
                ? d.segundo_pendiente_c.usuario.nombre
                : "--"
            } ${
              d.segundo_pendiente_c.usuario
                ? d.segundo_pendiente_c.usuario.apellido
                : "--"
            }`,
            `${
              d.tercero_pendiente_c.usuario
                ? d.tercero_pendiente_c.usuario.nombre
                : "--"
            } ${
              d.tercero_pendiente_c.usuario
                ? d.tercero_pendiente_c.usuario.apellido
                : "--"
            }`,
            `${
              d.cuarto_pendiente_c.usuario
                ? d.cuarto_pendiente_c.usuario.nombre
                : "--"
            } ${
              d.cuarto_pendiente_c.usuario
                ? d.cuarto_pendiente_c.usuario.apellido
                : "--"
            }`,
          ];

          this.series_pend_p = [
            {
              name: "Cantidad de riesgos pendientes",
              data: [
                d.primero_pendiente_p.cantidad,
                d.segundo_pendiente_p.cantidad,
                d.tercero_pendiente_p.cantidad,
                d.cuarto_pendiente_p.cantidad,
              ],
            },
          ];

          this.options_5_p.xaxis.categories = [
            `${
              d.primero_pendiente_p.usuario
                ? d.primero_pendiente_p.usuario.nombre
                : "--"
            } ${
              d.primero_pendiente_p.usuario
                ? d.primero_pendiente_p.usuario.apellido
                : "--"
            }`,
            `${
              d.segundo_pendiente_p.usuario
                ? d.segundo_pendiente_p.usuario.nombre
                : "--"
            } ${
              d.segundo_pendiente_p.usuario
                ? d.segundo_pendiente_p.usuario.apellido
                : "--"
            }`,
            `${
              d.tercero_pendiente_p.usuario
                ? d.tercero_pendiente_p.usuario.nombre
                : "--"
            } ${
              d.tercero_pendiente_p.usuario
                ? d.tercero_pendiente_p.usuario.apellido
                : "--"
            }`,
            `${
              d.cuarto_pendiente_p.usuario
                ? d.cuarto_pendiente_p.usuario.nombre
                : "--"
            } ${
              d.cuarto_pendiente_p.usuario
                ? d.cuarto_pendiente_p.usuario.apellido
                : "--"
            }`,
          ];

          this.render++;
        }
      }
    },
    getName(id) {
      let area = this.data.head.filter(function (el) {
        return el._id === id;
      });
      if (area.length > 0) {
        return area[0]["nombre"];
      } else {
        return "";
      }
    },
    getNameFaena(id) {
      let faena = this.listadoFaenas.filter(function (el) {
        return el.faena_id === id;
      });
      if (faena.length > 0) {
        return faena[0]["nombre"];
      } else {
        return "";
      }
    },
    getSumaBorrador(arrayList, area_id, fecha) {
      var total = 0;
      arrayList.forEach((n) => {
        if (n.area_id === area_id && n.fecha === fecha) {
          total = total + parseInt(n.borrador);
        }
      });
      return total;
    },
    getSumaRevision(arrayList, area_id, fecha) {
      var total = 0;
      arrayList.forEach((n) => {
        if (n.area_id === area_id && n.fecha === fecha) {
          total = total + parseInt(n.revision);
        }
      });
      return total;
    },
    getSumaNoiniciado(arrayList, area_id, fecha) {
      var total = 0;
      arrayList.forEach((n) => {
        if (n.area_id === area_id && n.fecha === fecha) {
          total = total + parseInt(n.no_iniciado);
        }
      });
      return total;
    },
    getSumaTiempoPromedio(arrayList, area_id) {
      var total = 0;
      arrayList.forEach((n) => {
        total = total + parseInt(n.tiempo_promedio);
      });
      return total;
    },
    getSuma(arrayList) {
      var total = 0;
      arrayList.forEach((n) => {
        total = total + parseInt(n.cantidad_mayor_dies);
      });
      return total;
    },
    convertDate(dateString) {
      var p = dateString.split(/\D/g);
      return [p[2], p[1], p[0]].join("/");
    },
    riesgosMasDies(fecha, area_id) {
      return this.data.data.filter(function (el) {
        return el.fecha === fecha && el.area_id === area_id;
      });
    },
    getDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getToday() {
      return moment().format("DD/MM/YYYY");
    },
    async getDataReporteGerencial() {
      this.loading = true;
      const response = await axios.post(
        `https://bhp.lifeon.cl/data-science/getDataReporteGerencial`,
        {
          area_master: this.area_master,
          inicio: this.getDate(this.inicio),
          fin: this.getDate(this.fin),
          tipo: this.tipo,
          faena_id: this.faena_selected,
        }
      );
      this.data = response.data;
      this.loading = false;
    },
    async setGerencia() {
      if (this.gerencia === "") {
        this.tipo = "GERENCIAS";
        this.area_master = this.gerencia_general;
      } else {
        this.tipo = "SUPERINTENDENCIAS";
        this.area_master = this.gerencia;
      }
      const response = await axios.post(
        `https://bhp.lifeon.cl/data-science/areasByPadre`,
        {
          area_padre_id: this.gerencia,
          faena_id: this.faena_selected,
        }
      );
      this.superintendencias = response.data;
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
      this.area_filtro = "";
      this.fecha_selected = "";
      this.getDataReporteGerencial();
    },
    async setArea() {
      if (this.area === "") {
        this.tipo = "AREAS";
        this.area_master = this.superintendencia;
      } else {
        this.tipo = "SUBAREAS";
        this.area_master = this.area;
      }
      this.area_filtro = "";
      this.fecha_selected = "";
      this.getDataReporteGerencial();
    },
    async setSuperintendencia() {
      if (this.superintendencia === "") {
        this.tipo = "SUPERINTENDENCIAS";
        this.area_master = this.gerencia;
      } else {
        this.tipo = "AREAS";
        this.area_master = this.superintendencia;
      }
      const response = await axios.post(
        `https://bhp.lifeon.cl/data-science/areasByPadre`,
        {
          area_padre_id: this.superintendencia,
          faena_id: this.faena_selected,
        }
      );
      this.areas = response.data;
      this.area = "";
      this.area_filtro = "";
      this.fecha_selected = "";
      this.getDataReporteGerencial();
    },
    async setGerenciaGeneral() {
      if (this.gerencia_general === "") {
        this.tipo = "GERENCIAS GENERALES";
        this.area_master = "";
      } else {
        this.tipo = "GERENCIAS";
        this.area_master = this.gerencia_general;
      }
      const response = await axios.post(
        `https://bhp.lifeon.cl/data-science/areasByPadre`,
        {
          area_padre_id: this.gerencia_general,
          faena_id: this.faena_selected,
        }
      );
      this.gerencias = response.data;
      this.gerencia = "";
      this.superintendencias = [];
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
      this.area_filtro = "";
      this.fecha_selected = "";
      this.getDataReporteGerencial();
    },
    async setValues() {
      const response = await axios.post(
        `https://bhp.lifeon.cl/data-science/areasByPadre`,
        {
          area_padre_id: this.area_id,
          faena_id: this.faena_selected,
        }
      );
      this.area_master = "";
      this.gerencias_generales = response.data;
      this.gerencias = [];
      this.superintendencias = [];
      this.areas = [];
      this.area = "";
      this.superintendencia = "";
      this.gerencia = "";
      this.gerencia_general = "";
      this.area_filtro = "";
      this.fecha_selected = "";
      this.tipo = "GERENCIAS GENERALES";
      this.getDataReporteGerencial();
    },
  },
};
</script>

<style scoped>
.ocultar {
  display: none;
}
.head {
  background-color: #dd5b32;
  color: white;
  font-weight: bold;
}
.head_2 {
  background-color: gray;
  color: white;
  font-weight: bold;
}
.green {
  color: green;
}

.red {
  color: red;
}
</style>